export enum NdfFormTheme {
    STANDARD = 'STANDARD',
    CAMPAIGN = 'CAMPAIGN',
    MOBILE = 'MOBILE',
}
